import { DateRange, Option, SplitBy } from "@intentsify/types";
import { atom } from "jotai";
import { atomWithReset, useResetAtom } from "jotai/utils";
import { ViewEnum } from "screens/IntentAnalysis/screens/CampaignsTrendingDomains/CampaignsTrendingDomains.types";
import { TrendingTopicsOptions } from "screens/IntentAnalysis/screens/CampaignsTrendingSignals/CampaignsTrendingSignals.types";

export const trendingTopicsDateRangeAtom = atomWithReset<DateRange>(
  DateRange.LastFourWeeks
);

export const topicsSplitByAtom = atomWithReset<SplitBy>(SplitBy.OneWeek);

export const topicsViewAtom = atomWithReset<ViewEnum>(ViewEnum.TimeSeries);

export const selectedTrendingTopicsAtom = atomWithReset<{
  campaignId: number | undefined;
  data: Array<Option<string>>;
}>({
  campaignId: undefined,
  data: [],
});

export const trendingTopicsOptionsStateAtom =
  atomWithReset<TrendingTopicsOptions>({
    isLoading: true,
    topics: [],
  });

export const trendingTopicsStateSelector = atom((get) => {
  const { isLoading, topics } = get(trendingTopicsOptionsStateAtom);
  const selectedDateRange = get(trendingTopicsDateRangeAtom);
  const selectedSplitBy = get(topicsSplitByAtom);
  const selectedView = get(topicsViewAtom);
  const selectedTopics = get(selectedTrendingTopicsAtom);

  return {
    isLoading,
    topicsOptions: topics,
    selectedDateRange,
    selectedSplitBy,
    selectedView,
    selectedTopics,
  };
});

export const useResetTrendingTopicsState = () => {
  const resetOptions = useResetAtom(trendingTopicsOptionsStateAtom);
  const resetDateRange = useResetAtom(trendingTopicsDateRangeAtom);
  const resetSplitBy = useResetAtom(topicsSplitByAtom);
  const resetView = useResetAtom(topicsViewAtom);
  const resetTopics = useResetAtom(selectedTrendingTopicsAtom);

  return () => {
    resetOptions();
    resetDateRange();
    resetSplitBy();
    resetView();
    resetTopics();
  };
};
